import { render } from "./widget-special-offers-skeleton.vue?vue&type=template&id=44833f6a&scoped=true"
import script from "./widget-special-offers-skeleton.vue?vue&type=script&lang=js"
export * from "./widget-special-offers-skeleton.vue?vue&type=script&lang=js"

import "./widget-special-offers-skeleton.vue?vue&type=style&index=0&id=44833f6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44833f6a"]])

export default __exports__